var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportAgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#6415ff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M417-86v-126h330v-285q0-106-78.5-178.5T481-748q-109 0-188.5 72.5T213-496v278h-68q-40.84 0-69.92-28T46-315v-97q0-21.72 11.5-40.86T86-486v-9q0-80 31.5-149t85-120q53.5-51 125-80.5T480-874q81 0 152.5 29.5t125 81Q811-712 842.5-643T874-494v8q19 13 29.5 32.5T914-411v95q0 26.43-9.5 50.21Q895-242 874-227v16q0 51-35 88t-86 37H417Zm-44.91-287Q353-373 340-385.91q-13-12.91-13-32T339.91-450q12.91-13 32-13T404-450.09q13 12.91 13 32T404.09-386q-12.91 13-32 13Zm216 0Q569-373 556-385.91q-13-12.91-13-32T555.91-450q12.91-13 32-13T620-450.09q13 12.91 13 32T620.09-386q-12.91 13-32 13ZM253-489q-3-93 65-156t163-63q82 0 145 51.5T703-524q-78-1-148-33t-112-98q-20 65-71.5 108.5T253-489Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportAgent);
export default __webpack_public_path__ + "static/media/support-agent.3458a4b477beb51382fd6eede57ef9d2.svg";
export { ForwardRef as ReactComponent };